import {SEARCH_IMEI} from '../constants/actionTypes';
import {convertResultToSymbol} from '../utils/imeiSearchUtils'
import initialState from './initialState';

export default function imeiSearchReducer(state = initialState.imeiSearch, action) {

  switch (action.type) {

    case SEARCH_IMEI:
      return {
        imei: action.imei,
        displayResult: action.displayResult,
        result: convertResultToSymbol(action.result)
      };


    default:
      return state;

  }

}
